<template>
    <div class="app-container">
      <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
        <el-row>
              <!-- <el-form-item label="专家姓名">
                <el-input v-model="queryParams.type_name" placeholder="请输入姓名" clearable  size="small" />
              </el-form-item>
              <el-form-item label="预留电话">
                <el-input v-model="queryParams.type_phone" placeholder="请输入电话号码" clearable  size="small" />
              </el-form-item> -->
           
              <!-- <el-form-item label="伴奏指法">
                <el-input v-model="queryParams.qumu_zhifa" placeholder="多个链接用英文逗号“,”分隔" clearable size="small" />
              </el-form-item> -->
        
  
          </el-row>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
            @click="handleQuery">查询</el-button>
          <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
        </el-form-item>
      </el-form>
  
      <div class="gap"></div>
      <div style="text-align: left; padding-left: 20px;">
        <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>
  
      </div>
      <el-table v-loading="loading" :data="list">
        <el-table-column label="商品名称" align="center" label-class-name='title' prop="goods_name" />
        <el-table-column label="商品类别" align="center" label-class-name='title' :formatter="transType" prop="goods_type" />
        <el-table-column label="商品售价" align="center" label-class-name='title' prop="goods_price" />
        <el-table-column  label="商品图片" align="center" width="200" label-class-name='title' prop="goods_url">
          <template slot-scope="scope">
              <div class="flex">
                 <img class="img" v-for="(item,index) in scope.row.goods_url.split(',')" :src = 'item'></img>
     
              </div>
        </template>

        </el-table-column>
        <el-table-column label="商品单位" align="center" label-class-name='title' prop="goods_unit" />
        <el-table-column label="商品重量" align="center" label-class-name='title' prop="goods_weight" />
        <el-table-column label="图片地址" align="center" label-class-name='title' prop="goods_url" />
        <el-table-column label="商品描述" align="center" label-class-name='title' prop="goods_desc" />
        <!-- <el-table-column label="商品原价" align="center" label-class-name='title' prop="origin_price" /> -->
        <!-- <el-table-column label="商品数量" align="center" label-class-name='title' prop="goods_num" /> -->
          <el-table-column label="操作" align="center" width="200" label-class-name='title'
          class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
              @click="handleUpdate(scope.row)">修改</el-button>
            <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
              @click="handleDelete(scope.row)">删除</el-button>
            <!-- <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                       size="mini"
                       type="primary"
                       @click="handleJudge(scope.row)">评价</el-button>
            <el-button class="inspect-button"
                       size="mini"
                       type="text"
                       icon="el-icon-view"
                       @click="handleView(scope.row)">查看</el-button>
   
            <el-button class="inspect-button"
                       size="mini"
                       type="text"
                       icon="el-icon-delete"
                       @click="handleDelete(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
  
  
      </el-table>
      <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
        @next-click="getList" />
      <!-- 操作日志详细 -->
      <el-dialog title="类别新增" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
        <el-form ref="form" :model="form" label-width="100px" size="mini">
          <el-row>
            <el-row>
            <el-col :span="24">
              <el-form-item label="商品名称">
                <el-input v-model="form.goods_name" placeholder="请输入商品名称" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品类别">
                <el-select style="width: 100%;" v-model="form.goods_type" placeholder="请选择">
    <el-option
      v-for="item in typeList"
      :key="item.type_code"
      :label="item.type_name"
      :value="item.type_code">
    </el-option>
  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品价格">
                <el-input v-model="form.goods_price" placeholder="请输入商品售价" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row>
 <el-row>
            <el-col :span="24">
              <el-form-item label="商品单位">
                <el-input v-model="form.goods_unit" placeholder="请输入商品单位" clearable  size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商品重量">
                <el-input v-model="form.goods_weight" placeholder="请输入商品重量（单位：kg）" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row>

                <el-row>
            <el-col :span="24">
              <el-form-item label="商品图片">
                        <el-upload
  :action="action"
  list-type="picture-card"
   :file-list="fileList"
    :on-change="handleChange"
  :on-preview="handlePictureCardPreview"
    :on-success="handleAvatarSuccess"
  :on-remove="handleRemove">
  <i class="el-icon-plus"></i>
</el-upload>
              </el-form-item>
            </el-col>
          </el-row>



<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
          </el-row>
    
         
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品描述">
                <el-input v-model="form.goods_desc" placeholder="请输入商品描述" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="商品原价">
                <el-input v-model="form.origin_price" placeholder="请输入商品原价" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="商品数量">
                <el-input v-model="form.goods_num" placeholder="请输入商品数量" clearable  size="small" />
              </el-form-item>
            </el-col>
          </el-row> -->
   
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="open = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  
  
  
  </template>
  
  <script>
  import config from '../../config/config'
  import {  typeAdd, typeList, typeDelete, typeUpdate } from '../api/type/index';
  import {  goodsAdd, goodsList, goodsDelete, goodsUpdate } from '../api/goods/index';
  export default {
    name: 'Operlog',
    data () {
      return {
        fileList:[],
        typeList: [],
        limit: 2,
        baseURL: '',  //  图片上传地址
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
  
  
        list: [],
        form: {
  
        },
        open: false,
        pageIndex: 1,
        pageSize: 10,
        // 禁用状态
        disabled: false,
        queryParams: {
  
        },
        loading: false,
        // table 列表数据
        list: [],
        // 总条数
        total: 0,
  
      }
    },
  
    created () {
      this.action = config.baseUrl + 'oss/fileUpload';
      console.log(this.action)
      this.handleQuery();

      typeList({}).then(res=>{
        this.typeList = res.data.list;
        console.log(res.data.list)
      })
    },
    methods: {
      handleChange(file, fileList) {
        debugger
        this.fileList = fileList;
         console.log(this.fileList)
      },
       handleRemove(file, fileList) {
        debugger
       this.fileList = fileList;
       console.log(this.fileList)
      },
      handleAvatarSuccess(res, file,fileList) {
        debugger
        // let list = this.fileList
        // list.push(res.data.url)
        // this.fileList = list
        // console.log(this.fileList)
      },
      handleUpdate (row) {
        this.open = true;
        this.form = {
          goods_id: row.goods_id,
          goods_url: row.goods_url,
          goods_name: row.goods_name,
          goods_weight: row.goods_weight,
          goods_price: row.goods_price,
          goods_desc: row.goods_desc,
          origin_price: row.origin_price,
          goods_unit: row.goods_unit,
          goods_type: row.goods_type-0,
        }
        debugger
        let fileList = row.goods_url.split(',')
        let listResult = fileList.map(item=>{
          debugger
          return {
            response:{
              data:{
                url:item
              }
            },
            url:item
          }
        })
        this.fileList = listResult
        console.log( this.fileList)
      },
      handleDelete (row) {
        let params = {
            goods_id: row.goods_id,
        }
        debugger
        this.$confirm('确认删除吗？')
          .then(() => {
            goodsDelete(params).then(res => {
              this.$message.success('删除成功')
              this.handleQuery()
            })
          })
          .catch(_ => { });
  
      },
      submit () {
        debugger
        console.log(this.fileList)
        let list = this.fileList.map(item=>{
        debugger
          return item.response.data.url
        })
        console.log(list)
        console.log(this.form)
        let params = this.form;
        console.log(params)
        params.goods_url = list.join(',');
        if(!params.goods_url){
          return this.$message.error('请输入商品地址')
        }
        if(!params.goods_name){
          return this.$message.error('请输入商品名称')
        }
        if(!params.goods_price){
          return this.$message.error('请输入商品价格')
        }
        if(!params.goods_desc){
          return this.$message.error('请输入商品描述')
        }
        // if(!params.origin_price){
        //   return this.$message.error('请输入商品原价')
        // }
        // if(!params.goods_num){
        //   return this.$message.error('请输入商品数量')
        // }
        if(!params.goods_type){
          return this.$message.error('请输入商品类别')
        }
       
        if (!params.goods_id) {
          goodsAdd(this.form).then(res => {
            this.$message.success('新增成功')
            this.open = false
            this.handleQuery()
          })
        } else {
          goodsUpdate(this.form).then(res => {
            this.$message.success('修改成功')
            console.log(res)
            this.open = false
            this.handleQuery()
          })
        }
      },
  
       // 类别
       transType (row) {
        let list = this.typeList
        for(let i=0;i<list.length;i++){
          if(list[i].type_code == row.goods_type){
            return list[i].type_name
          }
        }
      },
  
      //  退出
      logout () {
        localStorage.clear();
        this.$router.push('/')
      },
      // 新增按钮
      handleAdd () {
        this.open = true
        this.form = {
        }
      },
      // 查询按钮
      handleQuery () {
        let params = this.queryParams;
        params.pageIndex = this.pageIndex;
        params.pageSize = this.pageSize;
  
        this.list = []
        goodsList(params).then(res => {
          let list = res.data.list;
          this.list = res.data.list;
          
          console.log(this.list)
          this.total = res.data.total
          console.log(this.total)
        })
      },
  
      //  上一页面
      preClick (e) {
        this.pageIndex = e;
        if (pageIndex <= 1) { return }
        this.handleQuery()
      },
      // 下一页
      preClick () {
        let pageIndex = this.pageIndex + 1;
  
        if (pageIndex * this.pageSize >= this.total) {
          return
        }
        this.pageIndex = pageIndex;
        this.handleQuery()
      },
      // 获取列表
      getList (e) {
        this.pageIndex = e
        let params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }
        goodsList(params).then(res => {
  
          this.list = res.data.list;
          this.total = res.data.total
          console.log(this.total)
        })
      }
    }
  }
  </script>
  <style>
  .app-container {
    margin-top: 40px;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .gap {
    margin: 30px 10px;
  }
  
  .title {
    color: black;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .img{
    width: 50px;
    height: 50px;
    margin-left: 10px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px !important;
  }
  .el-upload--picture-card{
    width: 100px;
    height: 100px !important;
    line-height: 100px;
  }
  .img{
    width: 80px;
    margin-bottom: 10px;
    height: auto;
    border: 1px solid rgb(213, 206, 206);
    box-sizing: border-box;
  }
  .flex{
    display: flex;
    flex-wrap: wrap;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/views/goodsInfo.vue